import { toast } from "sonner";

// Strip HTML tags from rich-text content
export function stripHtml(html) {
  const div = document.createElement("div");
  div.innerHTML = html || "";
  return (div.textContent || div.innerText || "").trim();
}

// Copy question info to clipboard in a readable format
export async function copyQuestionInfo(q) {
  const lines = [
    `Soru: ${q.question_code || ""}`,
    "",
    stripHtml(q.question_text),
    "",
    `A) ${stripHtml(q.option_a) || "—"}`,
    `B) ${stripHtml(q.option_b) || "—"}`,
    `C) ${stripHtml(q.option_c) || "—"}`,
    `D) ${stripHtml(q.option_d) || "—"}`,
    "",
    `Doğru Cevap: ${q.correct_answer || "—"}`,
  ];
  if (q.question_image_url) lines.push("", `Görsel: ${q.question_image_url}`);
  if (q.question_video_url) lines.push(`Video: ${q.question_video_url}`);

  try {
    await navigator.clipboard.writeText(lines.join("\n"));
    toast.success("Bilgiler kopyalandı");
  } catch {
    toast.error("Kopyalama başarısız");
  }
}

// Download question as a JSON file
export function downloadQuestionJson(q) {
  const data = {
    id: q.id,
    question_code: q.question_code,
    archive_name: q.archive_name || null,
    question_text: stripHtml(q.question_text),
    options: {
      A: stripHtml(q.option_a) || null,
      B: stripHtml(q.option_b) || null,
      C: stripHtml(q.option_c) || null,
      D: stripHtml(q.option_d) || null,
    },
    correct_answer: q.correct_answer || null,
    taxonomy: {
      lesson_name: q.lesson_name || null,
      topic: q.topic || null,
      subtopic: q.subtopic || null,
      unit_name: q.unit_name || null,
      taxonomy_level_1: q.taxonomy_level_1 || null,
    },
    metadata: {
      difficulty_level: q.difficulty_level || null,
      display_type: q.display_type || null,
      source_name: q.source_name || null,
      exam_group: q.exam_group || null,
      tags: q.tags || null,
      status: q.status || null,
    },
    media: {
      image_url: q.question_image_url || null,
      video_url: q.question_video_url || null,
      type: q.question_image_url ? "image" : q.question_video_url ? "video" : "text",
    },
  };

  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${q.question_code || "soru"}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  toast.success(`${q.question_code || "soru"}.json indirildi`);
}
